import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { Clipboard } from "@capacitor/clipboard";

type SharePayload = {
  score: number;
  text: string; // 네가 지정한 텍스트
  url: string; // 링크 주소
  title?: string; // 선택
};

function buildShareText(p: SharePayload) {
  return `몬스팟 점수: ${p.score}\n${p.text}`;
}

export async function shareGameResult(payload: SharePayload) {
  const shareText = buildShareText(payload);
  const title = payload.title ?? "MonSpot";

  // 1) 네이티브 앱(캡시터)면 OS 공유 시트
  if (Capacitor.isNativePlatform()) {
    await Share.share({
      title,
      text: shareText,
      url: payload.url, // 일부 앱/OS는 url 필드를 별도로 더 잘 처리함
      dialogTitle: "공유하기",
    });
    return { mode: "native-share" as const };
  }

  // 2) 웹: navigator.share 지원이면 (주로 모바일 웹)
  if (typeof navigator !== "undefined" && "share" in navigator) {
    try {
      await navigator.share({ title, text: shareText, url: payload.url });
      return { mode: "web-share" as const };
    } catch {
      // 사용자가 취소한 경우도 여기로 올 수 있음 → 아래 복사로 폴백
    }
  }

  // 3) 웹: 클립보드 복사 폴백 (Capacitor Clipboard는 웹에서도 동작함)
  await Clipboard.write({ string: shareText });
  return { mode: "clipboard" as const };
}
